<p-select [options]="fontFamilies" [(ngModel)]="selectedFontFamily" [editable]="true" optionLabel="name"
    [disabled]="disableField" [showClear]="true" [appendTo]="'body'" (onChange)="setValueToForm()"></p-select>